import * as dev from "./dev.env";
import * as prod from "./prod.env";
import * as stage from "./stage.env";

export function getEnv(): { apiEndpoint: string } {
  if (process.env.NODE_ENV !== "production") {
    return dev.default;
  } else {
    return prod.default;
  }
}
